enum ELocalStorageKeys {
  AUTH_TOKEN = 'authToken',
  LOCALE = 'locale',
}

export default ELocalStorageKeys;
